import * as Sentry from '@sentry/react';
import { CustomBranding } from '../models/User';
import { Lesson } from './getLessonsInfo';

export const THEME_LINK_ID = 'dynamic-theme-css';

export const applyCustomBrandingStylesheet = (customBranding: string | null | undefined) => {
  if (!customBranding) return;

  // Absolute: a relative href resolves against document.baseURI, which is the current SPA route.
  const href = `${import.meta.env.BASE_URL}themes/${customBranding}.css`;
  const existing = document.getElementById(THEME_LINK_ID);
  if (existing?.getAttribute('href') === href) return;
  existing?.remove();

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.id = THEME_LINK_ID;
  link.onerror = () => Sentry.captureMessage(`Custom branding stylesheet failed to load: ${href}`, 'error');
  document.head.appendChild(link);
};

export const disableKhanForMiami = (customBranding: CustomBranding | undefined, url: string | null | undefined) => {
  if (customBranding === CustomBranding.MIAMI && url?.toLowerCase().includes('khan')) {
    return true;
  }
  return false;
};

export const isSomeVideoNotKhan = (customBranding: CustomBranding | undefined, lessons: Lesson[] | undefined) => {
  if (customBranding === CustomBranding.MIAMI && lessons) {
    return !lessons.every(lesson => lesson.link?.toLowerCase().includes('khan'));
  }
  return true;
};
